import { render } from "./Header.vue?vue&type=template&id=5a30f316"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=5a30f316&lang=scss"

import exportComponent from "F:\\Projeler\\vuejs\\eticposdashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__